<div class="pronunciation-train">
  @if (canSpeakQuestion()) {
    <button
      type="button"
      class="train-front-action train-question-audio-action btn btn-icon btn-outline-primary rounded-circle waves-effect"
      [class.train-audio-action-playing]="isQuestionAudioPlaying()"
      [attr.aria-label]="t()['train.listenQuestion']"
      [title]="t()['train.listenQuestion']"
      [disabled]="isAssessing() || isRecording()"
      (click)="speak.emit()"
    >
      <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
        <use href="/assets/icons/sprite.svg#volume-2"></use>
      </svg>
    </button>
  }

  <div class="pronunciation-train-target">
    @if (assessment()) {
      <div class="pronunciation-train-text pronunciation-train-tokenized">
        @for (token of pronunciationTokens(); track token.index) {
          @if (token.kind === "space") {
            <span class="pronunciation-text-space">{{ token.text }}</span>
          } @else if (token.word; as word) {
            <span class="pronunciation-word-wrap">
              <button
                type="button"
                [class]="'pronunciation-word ' + wordToneClass(word)"
                [class.pronunciation-word-selected]="
                  selectedWordIndex() === token.index
                "
                [attr.aria-expanded]="selectedWordIndex() === token.index"
                [attr.aria-label]="'Pronunciation details for ' + token.text"
                [title]="'Pronunciation details for ' + token.text"
                (click)="selectWord(token.index)"
                (keydown.enter)="selectWord(token.index)"
                (keydown.space)="
                  $event.preventDefault(); selectWord(token.index)
                "
              >
                {{ token.text }}
              </button>

              @if (selectedWordIndex() === token.index) {
                <section
                  class="pronunciation-word-detail"
                  aria-live="polite"
                  [attr.aria-label]="'Pronunciation detail for ' + token.text"
                >
                  <div class="pronunciation-word-detail-header">
                    <strong>{{ token.text }}</strong>
                    @if (word.score != null) {
                      <span>{{ word.score | number: "1.0-0" }}</span>
                    }
                  </div>

                  @if (word.phonemes.length > 0) {
                    <div class="pronunciation-word-detail-table" role="table">
                      <div
                        class="pronunciation-word-detail-row header"
                        role="row"
                      >
                        <span role="columnheader">Phone</span>
                        <span role="columnheader">Score</span>
                        <span role="columnheader">Status</span>
                      </div>
                      @for (phoneme of word.phonemes; track phoneme.phoneme) {
                        <div class="pronunciation-word-detail-row" role="row">
                          <span role="cell">{{ phoneme.phoneme }}</span>
                          <span role="cell">
                            @if (phoneme.score != null) {
                              {{ phoneme.score | number: "1.0-0" }}
                            } @else {
                              -
                            }
                          </span>
                          <span
                            role="cell"
                            [class]="
                              'pronunciation-phoneme-status ' +
                              phonemeStatusClass(phoneme)
                            "
                          >
                            {{ phonemeStatus(phoneme) }}
                          </span>
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="pronunciation-word-detail-empty">
                      {{ wordDetailEmptyMessage(word) }}
                    </div>
                  }
                </section>
              }
            </span>
          } @else {
            <span class="pronunciation-word-static">{{ token.text }}</span>
          }
        }
      </div>
    } @else {
      <div class="pronunciation-train-text">
        {{ card().frontText || t()["train.noQuestionText"] }}
      </div>
    }
  </div>

  <div class="pronunciation-train-actions">
    <button
      type="button"
      class="train-front-action btn btn-icon rounded-circle waves-effect"
      data-testid="pronunciation-record-toggle"
      [class.btn-danger]="isRecording()"
      [class.btn-outline-primary]="!isRecording()"
      [disabled]="isAssessing()"
      [attr.aria-label]="
        isRecording()
          ? t()['train.pronunciationStopRecording']
          : t()['train.pronunciationStartRecording']
      "
      [title]="
        isRecording()
          ? t()['train.pronunciationStopRecording']
          : t()['train.pronunciationStartRecording']
      "
      (click)="toggleRecording()"
    >
      <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
        <use href="/assets/icons/sprite.svg#mic"></use>
      </svg>
    </button>
  </div>

  @if (isRecording()) {
    <div class="pronunciation-train-status text-danger" role="status">
      {{ t()["train.pronunciationRecording"] }}
    </div>
  }

  @if (isAssessing()) {
    <div class="pronunciation-train-status text-body-secondary" role="status">
      {{ t()["train.pronunciationAssessing"] }}
    </div>
  }

  @if (errorMessage()) {
    <div class="alert alert-danger pronunciation-train-alert" role="alert">
      {{ errorMessage() }}
    </div>
  }

  @if (assessment(); as result) {
    <section class="pronunciation-train-result" aria-live="polite">
      <div class="pronunciation-train-score">
        <span>{{ result.overallScore | number: "1.0-0" }}</span>
        <small>{{ t()["train.pronunciationScore"] }}</small>
      </div>

      <div class="pronunciation-train-metrics">
        @if (result.accuracyScore != null) {
          <span
            >{{ t()["train.pronunciationAccuracy"] }}
            {{ result.accuracyScore | number: "1.0-0" }}</span
          >
        }
        @if (result.fluencyScore != null) {
          <span
            >{{ t()["train.pronunciationFluency"] }}
            {{ result.fluencyScore | number: "1.0-0" }}</span
          >
        }
        @if (result.completenessScore != null) {
          <span
            >{{ t()["train.pronunciationCompleteness"] }}
            {{ result.completenessScore | number: "1.0-0" }}</span
          >
        }
      </div>
    </section>
  }
</div>
